import { Input, KeyCode } from "../lib/Input";
import NetworkBehavior from "../lib/NetworkBehavior";

export default class Chat extends NetworkBehavior {

    LateUpdate(): void {
        if (!this.engine.clientPlayer) return;

        if (Input.GetKeyDown(KeyCode.Enter) && !Input.GetKey(KeyCode.AltLeft)) {
            const chatInput = document.createElement("input");
            chatInput.id = 'chat-input';
            chatInput.autocomplete = "off";

            chatInput.addEventListener("keydown", e => {
                if (e.code === KeyCode.Enter) {
                    if (!/^\s*$/.test(chatInput.value)) {
                        this.engine.sendChat(`${this.engine.clientName}: ${chatInput.value}`);
                    }

                    chatInput.remove();
                    this.engine.canvas.focus();
                }
            });

            document.body.appendChild(chatInput);
            chatInput.focus();
        }
    }

}